import { Identifiable } from "./identifiable";
import { id } from "./id";
import { resource, Resource } from "./resource";
import { Tag } from "./tag";
import { Attachment } from "./attachment";
import { List } from "./list";

type Event = {
  name: string;
  description: string;
  startTime: string;
  endTime: string;
  createdDate: string;
  organizer: Identifiable<Resource>;
  participants: Identifiable<Resource>[];
  tags: Tag[];
  commentsNbr?: number;
  attachmentsNbr?: number;
  attachments?: Identifiable<Attachment>[];
  keyRank: number;
  location?: Identifiable<Resource>;
  parentList?: Identifiable<List>;
  attributes?: { [key: string]: string };
  minStartDate?: string;
  maxEndDate?: string;
};

const event: Event = {
  name: "",
  description: "",
  startTime: "",
  createdDate: "",
  endTime: "",
  organizer: { uuid: id, ...resource },
  participants: [],
  keyRank: 0,
  tags: [],
};

export type { Event };

export { event };
